import { render, staticRenderFns } from "./VideoBanner.component.vue?vue&type=template&id=a45c8d7e&scoped=true"
import script from "./VideoBanner.component.vue?vue&type=script&lang=js"
export * from "./VideoBanner.component.vue?vue&type=script&lang=js"
import style0 from "./VideoBanner.component.vue?vue&type=style&index=0&id=a45c8d7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45c8d7e",
  null
  
)

export default component.exports